module.exports = __webpack_public_path__ + "img/error.dcb522de.gif";